import { usePage } from '@inertiajs/react'
import { derivativeUrl } from './imageUrls'

/**
 * Point an image URL at a derivative of the size the page actually paints.
 *
 * Three kinds of source get three treatments, all decided in ./imageUrls:
 * Storyblok goes to their free image service, our own masters go to the
 * self-hosted resizer, and anything else is returned untouched.
 *
 * `quality` and `format` are kept for call-site compatibility and ignored --
 * the resizer emits WebP at the quality set in config/images.php and
 * Storyblok is asked for WebP explicitly. No call site passes either today.
 */
export const optimizeImage = (url, width, quality = 80, format = 'auto') => {
    let settings

    // Called unconditionally: this runs inside components, so the hook has to
    // run on every render regardless of what the url turns out to be.
    const page = usePage()

    if (! url) {
        return url
    }

    if (typeof window === 'undefined') {
        // nodejs -- SSR cannot read Laravel config, so it reads the build-time env
        settings = {
            urls: {
                image_resize: import.meta.env.VITE_IMAGE_RESIZE_URL
            }
        }
    } else {
        settings = page.props.settings
    }

    // The background filter only accepts our image hosts. CMS Quay artwork
    // must keep using Storyblok's own image service.
    const isOwnImage = /^(?:https?:)?\/\/(?:bucket|cdn|www)\.coolframes\.com\//i.test(url)
    if (isOwnImage && url.indexOf('quay') >= 0 && url.indexOf('img/filter') === -1) {
        // Need to strip gray backgrounds on source images
        return 'https://www.coolframes.com/img/filter/bg/' + url + '?fuzz=2'
    }

    return derivativeUrl(url, width, settings?.urls?.image_resize)
}
